module.exports = __webpack_public_path__ + "static/assets/197523614eaff63c76494f71e4486ff8.png";